import { useQuery } from "@tanstack/react-query";
import { SectionModel } from "providers/loans/loan-section.model";
import { apiRequest } from "utils/api";

interface ApiResponse {
	sections: SectionModel[];
}

async function fetchLoanSection(): Promise<SectionModel[]> {
	const response = await apiRequest<ApiResponse>(
		"/supabase/loan_section/select"
	);
	return response.sections;
}

export const useLoanSection = () => {
	return useQuery({
		queryKey: ["loanSection"],
		queryFn: fetchLoanSection,
		staleTime: 1000 * 60 * 10,
		retry: 2,
	});
};
